/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";

/** @module core/modules/create-heartbeat-timeout */

/**
 * @callback createHeartbeatTimeoutFunction
 * @param {Function} callback - Trigger callback.
 * @param {number} threshold - Timer duration.
 * @param {boolean} [defuse] - Defuse trigger.
 * @returns {void} Void.
 */

/**
 * @description Creates an inverse trigger function.
 * @returns {createHeartbeatTimeoutFunction} Inverse trigger function.
 */
function createHeartbeatTimeout() {
  var _this = this,
      _context;

  var timer = null;
  return _bindInstanceProperty(_context = function _context(callback, threshold, defuse) {
    var _this2 = this,
        _context2;

    _newArrowCheck(this, _this);

    // CLEAR TIMER
    clearTimeout(timer);

    if (defuse) {
      return;
    } // RECREATE TIMER


    timer = _setTimeout(_bindInstanceProperty(_context2 = function _context2() {
      _newArrowCheck(this, _this2);

      callback();
    }).call(_context2, this), threshold);
  }).call(_context, this);
}

export { createHeartbeatTimeout };